import React from 'react';

export default function ComparisonTable() {
  const features = [
    {
      feature: 'Uses our decades of experience and AI algorithms that show you how to answer the interviewer\'s questions based on their personality profile and role.',
      benefit: 'Don\'t consider the interviewer\'s background or needs. The results are generic, unclear, or misaligned with your background, the company, and the interviewer'
    },
    {
      feature: 'Shows you what you need to focus on and guides you with the best answers to say.',
      benefit: 'Requires you to guess what the interviewer is looking for.'
    },
    {
      feature: 'Uses the ArcAdvantage framework to create a crystal-clear, results-focused resume.',
      benefit: 'Won\'t separate you from the million other candidates - and being asked to interview.'
    },
    {
      feature: 'Provides instant results - get custom preparation in minutes that is ready to use.',
      benefit: 'Cause you to spend hours doing research and preparation.'
    },
  ];

  return (
    <section className="py-20">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold sm:text-5xl md:text-6xl text-center text-gray-900 mb-8">
            What makes InterviewAdvantage.ai <span className="text-blue-500">different?</span>
          </h2>

          <div className="flex flex-col md:flex-row gap-6">
            {/* InterviewAdvantage.ai Column */}
            <div className="w-full md:w-1/2 border border-gray-200 bg-blue-50 rounded-lg">
              <div className="rounded-t-lg p-4">
                <h3 className="text-xl font-semibold text-gray-600">InterviewAdvantage.ai</h3>
              </div>
              <div className="flex flex-col gap-4 p-4 rounded-b-lg">
                {features.map((item, index) => (
                  <div key={index} className="p-4 bg-blue-50  rounded-lg">
                    <p className="text-gray-800">{item.feature}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Other Methods Column */}
            <div className="w-full md:w-1/2">
              <div className="bg-gray-50 rounded-t-lg p-4">
                <h3 className="text-xl font-semibold text-gray-600">Other Methods</h3>
              </div>
              <div className="flex flex-col gap-4 bg-gray-50 p-4 rounded-b-lg">
                {features.map((item, index) => (
                  <div key={index} className="p-4 rounded-lg">
                    <p className="text-gray-600">{item.benefit}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}